import styled from 'styled-components'; // Fixing the build
import theme from 'theme';

import { ModalContent, ModalFooter, ModalGrid, ModalHeader } from 'components/GlobalModal';
import KoalaIconButton from 'koala/components/IconButton';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { setGlobalModalContent } from 'state/actions/globalUIActions';
// import { useMutation, useQuery, useQueryCache } from 'react-query';
import KoalaButton from 'koala/components/Button';
import FormField from 'components/FormField';
import KoalaTextButton from 'koala/components/TextButton';
import { useMutation, useQueryCache } from 'react-query';
import * as remoteApi from 'api/remote';
import queryKeys from 'config/queryKeys';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Form = styled.form`
  .segment-input {
    margin-bottom: ${theme.spacing.x1};
  }

  textarea {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif,
      'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol' !important;
    line-height: 1.4;
    font-size: 1.4rem;
    padding: ${theme.spacing.x1};
    min-height: 20rem;
    border-radius: 4px;
    border: 1px solid ${theme.colors.N20};
    width: 100%;
    resize: none;
  }
`;

function ConnectAmplitude() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const translationKey = 'modals.connectGoogleServiceAccount';
  const { workspaceSlug } = useParams<{
    workspaceSlug: string;
  }>();

  const [jsonKey, setJsonKey] = useState('');
  const queryCache = useQueryCache();

  const [installAmplitudeMutation, { isLoading }]: [any, any] = useMutation(remoteApi.installGoogleServiceAccount, {
    onSuccess: () => {
      queryCache.invalidateQueries([queryKeys.integrations]);
      dispatch(setGlobalModalContent(''));
    },
  });

  const handleCancel = (e: React.MouseEvent) => {
    e.preventDefault();
    dispatch(setGlobalModalContent(''));
  };

  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    const params = {
      body: {
        json_key: jsonKey,
      },
      workspaceSlug: workspaceSlug,
    };
    installAmplitudeMutation(params);
  };

  const allowSave = jsonKey && !isLoading;

  return (
    <ModalGrid>
      <ModalHeader>
        <h2>{t(`${translationKey}.title`)}</h2>
        <KoalaIconButton onClick={handleCancel} iconName="close" />
      </ModalHeader>
      <ModalContent>
        <Form onSubmit={handleSave}>
          <FormField>
            <label>{t(`${translationKey}.jsonKey`)}</label>
            <textarea
              placeholder={t(`${translationKey}.jsonKeyPlaceholder`) ?? 'JSON Key'}
              value={jsonKey}
              onChange={(e) => setJsonKey(e.currentTarget.value)}
            />
          </FormField>
        </Form>
      </ModalContent>
      <ModalFooter>
        <KoalaButton onClick={handleSave} disabled={!allowSave} loading={isLoading}>
          {t('shared.save')}
        </KoalaButton>
        <KoalaTextButton onClick={handleCancel}>{t('shared.cancel')}</KoalaTextButton>
      </ModalFooter>
    </ModalGrid>
  );
}

export default ConnectAmplitude;
